export interface KpiDefinition {
  id: string;
  label_sv: string;
  label_en: string;
  category: 'finance' | 'action' | 'project' | 'customer';
  icon: string;
  description_sv: string;
  description_en: string;
  size: 'small' | 'large';
}

export const KPI_CATEGORIES: Record<string, { label_sv: string; label_en: string; icon: string }> = {
  finance: { label_sv: 'Kassaflöde och finans', label_en: 'Cash Flow & Finance', icon: 'dollar-sign' },
  action: { label_sv: 'Åtgärder och uppföljning', label_en: 'Action & Follow-up', icon: 'zap' },
  project: { label_sv: 'Projekt och leverans', label_en: 'Projects & Delivery', icon: 'folder' },
  customer: { label_sv: 'Beställare och tillväxt', label_en: 'Clients & Growth', icon: 'users' }
};

// The KPIs a company can show on its start page (admin defaults and
// "Anpassa"). Mina Projekt is always shown and is not a choice.
export const KPI_REGISTRY: KpiDefinition[] = [
  {
    id: 'completedVolume',
    label_sv: 'Utbetalt till er',
    label_en: 'Paid out to you',
    category: 'finance',
    icon: 'check-square',
    description_sv: 'Utbetalt för attesterade etapper',
    description_en: 'Paid out for attested stages',
    size: 'small'
  },
  {
    id: 'totalPaid',
    label_sv: 'Säkrat hos Etappio',
    label_en: 'Secured with Etappio',
    category: 'finance',
    icon: 'check-circle',
    description_sv: 'Insatt av beställaren och ännu inte utbetalt; betalas ut när beställaren attesterar',
    description_en: 'Deposited by the client and not yet paid out; paid out when the client attests',
    size: 'small'
  },
  {
    id: 'outstandingBalance',
    label_sv: 'Väntar på beställarens insättning',
    label_en: "Awaiting the client's deposit",
    category: 'finance',
    icon: 'clock',
    description_sv: 'Signerat belopp som beställaren ännu inte har satt in',
    description_en: 'Signed amount the client has not deposited yet',
    size: 'small'
  },
  {
    id: 'totalContractValue',
    label_sv: 'Osignerade kontrakt',
    label_en: 'Unsigned contracts',
    category: 'finance',
    icon: 'file-text',
    description_sv: 'Kontraktssumman för kontrakt som inte är signerade av båda parter (utkast utan belopp räknas inte)',
    description_en: 'Contract sum of contracts not yet signed by both parties (drafts without an amount are left out)',
    size: 'small'
  },
  {
    id: 'activeVsCompleted',
    label_sv: 'Aktiva projekt',
    label_en: 'Active projects',
    category: 'project',
    icon: 'activity',
    description_sv: 'Projekt som pågår just nu, med knappen Skapa projekt',
    description_en: 'Projects underway right now, with the Create project button',
    size: 'small'
  },
  {
    id: 'customersWithoutProject',
    label_sv: 'Beställare utan projekt',
    label_en: 'Clients without a project',
    category: 'action',
    icon: 'folder-plus',
    description_sv: 'Beställare som är kopplade men saknar projekt',
    description_en: 'Connected clients without a project yet',
    size: 'small'
  },
  {
    id: 'customers',
    label_sv: 'Beställare',
    label_en: 'Clients',
    category: 'customer',
    icon: 'users',
    description_sv: 'Antal beställare, hur många som är verifierade och hur många som är nya denna månad',
    description_en: 'Number of clients, how many are verified and how many are new this month',
    size: 'small'
  },
  {
    id: 'projectStatusChart',
    label_sv: 'Projekt per status (diagram)',
    label_en: 'Projects by Status (chart)',
    category: 'project',
    icon: 'bar-chart-2',
    description_sv: 'Stapeldiagram över projekt per status, med datumfilter',
    description_en: 'Bar chart of projects by status with date filter',
    size: 'large'
  }
];
